export default {
  name: 'Newsletter',
  htmlId: '',
};
